import { Component, Input, OnInit } from "@angular/core";
import { DateTime } from "luxon";
import { ForumsService } from "src/app/forums/forums.service";
import { SsoUser } from "src/app/shared/model/user.model";
import { SsoAuthService } from "src/app/shared/services/sso-auth.service";

@Component({
  selector: "widget-forums",
  templateUrl: "./widget-forums.component.html",
  styleUrls: ["./widget-forums.component.scss"],
})
export class WidgetForumsComponent implements OnInit {
  @Input() widgetConfig;
  categories = [
    { name: "All Categories", value: "all", color: "" },
    { name: "FAQ", value: "FAQ", color: "#D2DBFE" },
    { name: "General", value: "General", color: "#CCECD4" },
    { name: "Help", value: "Help", color: "#E4D9FF" },
    { name: "Report a problem", value: "Report a problem", color: "#FBD1D1" },
  ];
  posts = [];
  loadingPosts = false;
  ssoUser: SsoUser = null;

  constructor(
    private ssoService: SsoAuthService,
    private forumsService: ForumsService
  ) {}

  ngOnInit() {
    this.init();
  }

  async init() {
    this.ssoUser = await this.ssoService.getCurrentSsoUser();
    try {
      this.loadingPosts = true;
      const refPosts = await this.forumsService.searchForumPosts({
        searchTerm: "",
        sortExpresssion: "createdAt:desc",
        isHidden: false,
        pagination: {
          pageSize: 4,
          currentPage: 0,
        },
      });

      this.posts =
        refPosts.hits?.map((hit) => {
          const post = hit.document;
          this.extendPost(post);
          return post;
        }) || [];
    } catch (error) {
      // TODO
      console.error(error);
    } finally {
      this.loadingPosts = false;
    }
  }

  private extendPost(post: any) {
    Object.assign(post, {
      initials: post.createdByName
        .match(/(\b\S)?/g)
        .join("")
        .toUpperCase(),
      category: this.categories.find((c) => c.value === post.category),
      createdAt: DateTime.fromSeconds(post.createdAt, {
        zone: "utc",
      }).toISO({ includeOffset: false }),
    });
    return post;
  }
}
